import React, { useCallback } from 'react';
import { TableColumn } from 'tea-component';
import { useIntl, history, getLocale } from 'umi';
import ColumnsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import SortBy from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { DataSourceBubbleInfo, DATASOURCE_NAME } from '@/pages/intelligence/components/DataSourceComponents';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import { valueFormat, growthFormat, } from '@/pages/intelligence/utils/commonUtils';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import { Content, } from './Tips';
import { ITopChartsCompaniesColumnType, ITopChartsCompaniesRank, } from '@/pages/intelligence/pages/TopCharts/Companies/components/CompaniesCore/types';
import { convertNumber } from '@/pages/intelligence/pages/Streaming/Games/utils';
import { LANGUAGE_CN } from '@/pages/home/_config/config';

export const COLUMNS_SORT_METADATAS_MAPPING: {
  [key: string]: {
    dataSource: string;
    key: string;
    title: string;
    title_cn: string;
  };
} = {
  Hours_Watched: {
    dataSource: '',
    key: "hoursWatched",
    // TODO:有时间处理一下key
    title: 'Hours Watched(hours)',
    title_cn: '观看时长(小时)',
    //  'dbi_company_metrics_sum_revenue',
  },
  Peak_CCV: {
    dataSource: '',
    key: 'peackCCV',
    title: 'Peak CCV',
    title_cn: '直播观众峰值',
    //  'dbi_company_metrics_mobile_revenue',
  },
  Avg_CCV: {
    dataSource: '',
    key: 'avgCCV',
    title: 'Avg CCV',
    title_cn: '直播观众平均值',
    // 'dbi_company_metrics_pc_revenue',
  },
  Airtime: {
    dataSource: '',
    key: "airtime",
    title: 'Airtime(hours)',
    title_cn: '直播时长(小时)',
    //  'dbi_company_metrics_console_revenue',
  },
};
export interface IColumnMetaData {
  dataSources: string[]; // 前端表头展示数据源icon用的数据源
  dataSource: string; // 后端排序用的数据源
  key: string;
  title: string;
  content: React.ReactNode;
  tipText: React.ReactNode;
}

// Kol榜单所有的列 元数据
export const COLUMNS_METADATAS_MAPPING: {
  [key: string]: IColumnMetaData;
} = {
  // Kol
  Hours_Watched: {
    // 'streamHatchet'
    dataSources: ['hatchet',],
    ...COLUMNS_SORT_METADATAS_MAPPING.Hours_Watched,
    content: <Content title="sum" />,
    tipText: '',
  },
  Peak_CCV: {
    dataSources: ['hatchet'],
    ...COLUMNS_SORT_METADATAS_MAPPING.Peak_CCV,
    content: <Content title="peak" />,
    tipText: '',
  },
  Avg_CCV: {
    dataSources: ['hatchet'],
    ...COLUMNS_SORT_METADATAS_MAPPING.Avg_CCV,
    content: <Content title="avg" />,
    tipText: '',
  },
  Airtime: {
    dataSources: ['hatchet'],
    ...COLUMNS_SORT_METADATAS_MAPPING.Airtime,
    content: <Content title="sum" />,
    tipText: '',
  },
};

const PAGE_DOMAINS_MAPPING: {
  [key in string]: string;
} = {
  [COLUMNS_SORT_METADATAS_MAPPING.Hours_Watched.key]: 'dbi_Primary_hours_watched',
  [COLUMNS_SORT_METADATAS_MAPPING.Peak_CCV.key]: 'dbi_Primary_peak',
  [COLUMNS_SORT_METADATAS_MAPPING.Avg_CCV.key]: 'dbi_Primary_avg',
  [COLUMNS_SORT_METADATAS_MAPPING.Airtime.key]: 'dbi_Primary_airtime',
};


export function CompaniesMetricColumn(params: ITopChartsCompaniesColumnType): TableColumn<ITopChartsCompaniesRank> {
  const {
    topChartsType,
    dataSources,
    dataSource,
    key,
    title,
    title_cn,
    content,
    tipText,
    sortMetric,
    currentSortKey,
    currentSortValue,
    onSortChage,
  } = params || {};
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const isMentions = topChartsType === 'top_companies_mentions';
  // const translatedTitle = formatMessage({ id: title });
  const translatedTitle = locale === LANGUAGE_CN ? title_cn ?? title : title;
  const translatedDomainText = (() => {
    const translateKey = PAGE_DOMAINS_MAPPING[key];
    const pageDomainName = translateKey ? formatMessage({ id: translateKey }) : '';

    return (
      <>
        {/* {dataSources?.length === 1 && <img src={getDataSourceIcon(dataSources?.[0])} alt="" />} */}
        {pageDomainName}
      </>
    );
  })();

  const customActions = (metric:string) => {
    history.push({
      pathname: '/intelligence/sourcesMetrics/metrics/IntelligenceMetrics',
      query: {
        pageid: 'Stream Hatchet',
        metric
      },
    });
  }
  return {
    key,
    width: 230,
    align: 'center',
    header: () => {
      const andText = formatMessage({ id: 'dbi_company_and' });
      return (
        <ColumnsCenter width={230} align={'right'}>
          <SortBy
            title={translatedTitle}
            content={content}
            tipText={tipText}
            svgIcon={!isMentions && getDataSourceIcon(dataSources[0])}
            svgIcon1={!isMentions && getDataSourceIcon(dataSources[1])}
            svgTip={
              !isMentions && (
                <>
                  <DataSourceBubbleInfo
                    dataOfDom={translatedDomainText}
                    customActions={()=>customActions(sortMetric)}
                    metricKey={sortMetric}
                    comesFormDom={
                      <>
                        {dataSources.map((item) => {
                          const dataSourceIcon = getDataSourceIcon(item);
                          return <img src={dataSourceIcon} alt="" />;
                        })}
                        {dataSources.map((dataSource) => DATASOURCE_NAME?.[dataSource].replace(DATASOURCE_NAME?.[dataSource], "Stream Hatchet.")).join(andText)}
                      </>
                    }
                  />
                </>
              )
            }
            list={[
              {
                key: `${key}_0`,
                sortMetric,
                orderSource: dataSource,
                text: translatedTitle,
                title: translatedTitle,
                ratioType: 0,
              },
              {
                key: `${key}_1`,
                sortMetric,
                orderSource: dataSource,
                text: `${translatedTitle}:Change(%)`,
                title: `${translatedTitle}(%)`,
                ratioType: 1,
              },
            ]}
            defaultKey={currentSortKey}
            defaultValue={currentSortValue}
            onChange={onSortChage}
          />
        </ColumnsCenter>
      );
    },
    render: (cvm) => {
      const metrics = cvm?.metric_list || [];
      const metric = metrics?.find((item) => item?.metric === sortMetric);
      const metricValue = metric?.value;
      const metricGrowthRatio = metric?.growth_ratio || convertNumber(metric?.dod);
      const metricGrowthDataObj = Number.isNaN(metricGrowthRatio)
        ? {
          type: '',
          value: '-',
        }
        : growthFormat({
          value: metricGrowthRatio,
          valueType: 'percentValue',
          hasPoint: 'all',
          fixedNum: 0,
          maxNumber: 99999,
        });
      return (
        <ColumnsCenter width={230} align={'center'}>
          <TableShowData
            value={valueFormat(metricValue)}
            type={metricGrowthDataObj?.type}
            growth={metricGrowthDataObj?.value}
            maxNumber={'99999+%'}
          />
        </ColumnsCenter>
      );
    },
  };
}
